<!DOCTYPE html>
<app-dataview [identifier]="'settings-view'" [title]="title" [treedata]="menuItems" [showtree]="true" [sidepaneltitle]="'Settings'" [url]="url"></app-dataview>